const priceHelper = {
  isZero(value: string) {
    return value === '0,00 €' || value === 'CHF 0.00';
  }
}

export {priceHelper}
